import React from 'react';
import { injectIntl } from 'react-intl';
import { useQuery, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { findIndex } from 'lodash';

import { Tooltip, ImagePlaceholder } from 'components';
import { EditIcon } from 'icons';
import theme from 'utils/theme';

import messages from 'messages';

function BagItem({ item, index, ...props }) {
    const queryClient = useQueryClient();

    const restaurant = useQuery('restaurant')?.data || {};
    const bag = useQuery('bag')?.data || {};
    const history = useHistory();

    const { recipients, amount, quantity, type, color, name } = item;
    const { formatMessage } = props.intl;

    const renderRecipients = () => {
        if (recipients[0].sameReceiver) {
            return (
                <div className="tooltip-recipients">
                    <p key={0}>
                        {recipients[0].name}
                        <span>{recipients[0].email}</span>
                    </p>
                </div>
            );
        }

        return (
            <div className="tooltip-recipients">
                {recipients?.map((item, index) => (
                    <p key={index}>
                        {item.name}
                        <span>{item.email}</span>
                    </p>
                ))}
            </div>
        );
    };

    const renderPrice = () => {
        return (
            <p className="currency">
                {restaurant.currency} {quantity * amount}{' '}
            </p>
        );
    };

    const removeItem = () => {
        const position = item.index;
        const index = findIndex(bag, { index: position });

        bag.splice(index, 1);

        queryClient.invalidateQueries('bag');
        localStorage.setItem('bag', JSON.stringify(bag));
    };

    const edit = () => {
        if (item.type === 'amount') {
            history.push(`/${restaurant.domain}/amount/edit/${item.index}`);

            return;
        }

        history.push(`/${restaurant.domain}/experience/edit/${item.index}`);
    };

    const renderName = () => {
        return name === 'amount'
            ? `${formatMessage(
                  messages.genericLabelValue,
              )} ${restaurant.currency.toUpperCase()} ${amount}`
            : name;
    };

    return (
        <div className="bag-item">
            <figure>
                <ImagePlaceholder color={color} text={type} />
            </figure>

            <div className="data">
                <div className="header-item">
                    <h2>{renderName()}</h2>
                    <EditIcon
                        size={16}
                        className="icon"
                        onClick={() => edit()}
                        data-test="edit-gift-card"
                    />
                </div>
                <p className="amount">
                    {quantity}x <span className="currency">{restaurant.currency}</span> {amount}
                </p>
                <div className="tooltip">
                    <Tooltip
                        message={renderRecipients()}
                        position={'bottom'}
                        background={theme.colors.white}
                        color={'black'}
                    >
                        <p>
                            {recipients?.length}{' '}
                            {recipients.length > 1
                                ? formatMessage(messages.genericLabelRecipients)
                                : formatMessage(messages.genericLabelRecipient)}
                        </p>
                    </Tooltip>
                </div>
                <div className="footer-item">
                    <span onClick={() => removeItem()} data-test="remove-gift-card">
                        {formatMessage(messages.genericRemove)}
                    </span>
                    {renderPrice()}
                </div>
            </div>
        </div>
    );
}

export default injectIntl(BagItem);
